<script lang="ts" setup>
defineProps({
  hasBorders: {
    default: true,
    type: Boolean,
  },
  width: {
    default: '',
    type: String,
  },
})

const containerRef = ref<HTMLDivElement>()

defineExpose({ containerRef })
</script>

<template>
  <div
    class="size-full overflow-x-auto rounded-lg bg-gray-100 dark:bg-gray-900"
    :class="{ 'ring-texture p-2 shadow': hasBorders }"
  >
    <div
      ref="containerRef"
      class="relative flex size-full items-center justify-center overflow-hidden rounded-lg px-8 pb-10 pt-6 md:w-full md:px-12"
      :class="[width]"
    >
      <AnimationDotsPattern />

      <div class="flex size-full items-center justify-between p-8 lg:p-4">
        <slot />
      </div>
    </div>
  </div>
</template>
